<template>
  <v-icon class="nx-media-info">{{ icon }}</v-icon>
</template>

<script>
/**
 * MediaImage Component
 *
 * ...
 *
 * @property {String}  type
 */
export default {
  name: 'nx-media-info',
  props: {
    icon: String,
  },
};
</script>

<style lang="stylus">
.nx-media-info {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &.icon {
    position: absolute;
    z-index: 1;
    height: 24px;
    width: 24px;
    color: rgba(#8c8c9c, 0.4);
    font-size: 20px;
  }
}
</style>
